export default __webpack_public_path__ + "static/media/content-deco-2.a219820d.webp";